import React, { useState, useEffect } from "react";

import "./IncorrectGuesses.css";

const Stopwatch = (props) => {
  const { incorrectGuesses } = props;
  return (
    <div
      className={`stat-chip ${incorrectGuesses > 0 ? "has-misses" : ""}`}
      aria-label="Incorrect guesses"
    >
      <span className="stat-chip-icon">✕</span>
      {incorrectGuesses}
    </div>
  );
};

export default Stopwatch;
